/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

import FullLoader from '../components/FullLoader';
import { useOrganization } from '../context/OrganizationContext';
import { useUser } from '../context/UserContext';
import { organizations } from '../model/organization';
import Auth from '../screens/Auth';
import AuthOrApp from '../screens/AuthOrApp';
import Home from '../screens/Home';
import { DefaultLayout } from '../styles/defaultLayout';

const PrivateRoute = ({
	component: Component,
	path,
	...rest
}: {
	component: any;
	path: string;
}) => {
	const { user } = useUser();
	return (
		<Route {...rest} render={props => (user ? <Component {...props} /> : <Redirect to="/" />)} />
	);
};

export const Routes = () => {
	const { organization, setOrganization } = useOrganization();

	useEffect(() => {
		if (!organization) {
			const defaultOrganization = process.env.REACT_APP_DEFAULT_ORGANIZATION;
			const defaultOrganizationUrl = process.env.REACT_APP_PUBLIC_APP_DOMAIN;

			const url = window.location.hostname;
			const regex = url.match(/.+\.(([a-z]+)\.([a-z]+\.[a-z]+))[:\d]*/);
			const mainUrl = regex ? regex[1] : defaultOrganizationUrl;
			let newOrganization = regex ? regex[2] : defaultOrganization;
			setOrganization({
				...(typeof newOrganization === 'string' ? organizations[newOrganization] : {}),
				url: mainUrl,
			});
		}
	}, [setOrganization, organization]);

	if (!organization) return <FullLoader />;

	return (
		<DefaultLayout>
			<Helmet>
				<title>{`BackOffice ${organization.name}`}</title>
				<meta charSet="utf-8" />
				<meta name="description" content={organization.description} />
				<meta property="og:title" content={organization.name} />
				<meta property="og:image" content={organization.imgUri} />
				{/* <link rel="shortcut icon" href={organization.favicon} />
				<link rel="manifest" href="%PUBLIC_URL%/manifest.json" /> */}
				<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
			</Helmet>
			<Switch>
				<Route path="/" exact component={AuthOrApp} />
				<Route path="/login" exact component={Auth} />
				<PrivateRoute path="/home" component={Home} />
			</Switch>
		</DefaultLayout>
	);
};
